import { useNavigate } from '@tanstack/react-router'
import { useEffect, type MouseEvent } from 'react'
import { createPortal } from 'react-dom'
import '../inventoree/UnassignedBand.css'
import { useShellSlots } from './shellSlots'

/*
 * APLICATII CARE ASTEAPTA, pastila rosie din BARA MODULULUI - ca la
 * Inventoree pentru statiile fara utilizator (`UnassignedBand`, `badge`).
 *
 * Coordonatoarea, 5 octombrie 2026: intai "ca la Unknown, sus rosu" - si a
 * stat in bara de sus globala, cu iconita si pip. Apoi: "Nu acolo." Locul e
 * capul modulului, langa Search (`li.tk-header-tools`, dupa
 * `#current-section`), pe paginile Overview > Applications: lista (si fila
 * Suggested), harta, fisa aplicatiei. Din bara globala a fost scoasa, ca sa nu
 * fie doua numere de tinut la fel.
 *
 * Numarul e cel al benzii "N applications need completing" din lista:
 * aplicatiile gasite de detectie si neconfirmate (`pending_review`), cele
 * active cu checklistul incomplet si cele cu reverificarea venita - pe firma
 * CURENTA. Clic: lista de aplicatii, cu banda deschisa si adusa in vedere.
 *
 * Valoarea vine din raspunsul de shell (`appsAttention`, `Completeness` pe
 * randurile firmei) si e 0 pentru cine n-are `inventoree.cmdb.read`. La 0
 * pastila nu se scrie, si nici locul din antet nu se cere.
 */

export const APPS_ATTENTION_HREF = '/app/applications?attention=1'

/** Evenimentul cu care banda se deschide cand lista e deja pe ecran. */
export const APPS_ATTENTION_EVENT = 'od:apps-attention'

export function appsAttentionTitle(count: number): string {
  return count === 1 ? '1 application needs completing' : `${count} applications need completing`
}

export function AppsAttentionPill({ count }: { count: number | undefined }) {
  const n = count ?? 0
  return n > 0 ? <Pill count={n} /> : null
}

function Pill({ count }: { count: number }) {
  const navigate = useNavigate()
  const { claimHeaderTools, headerTools } = useShellSlots()
  /* Locul din antet se cere numai cat timp pastila e pe ecran. */
  useEffect(() => claimHeaderTools(), [claimHeaderTools])
  if (!headerTools) return null
  const title = appsAttentionTitle(count)

  const open = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    void Promise.resolve(navigate({ to: '/applications', search: { attention: 1 } })).then(() =>
      window.dispatchEvent(new Event(APPS_ATTENTION_EVENT)),
    )
  }

  return createPortal(
    <a
      className="btn od-unknown-badge tk-header-extra"
      data-testid="apps-attention-pill"
      href={APPS_ATTENTION_HREF}
      title={title}
      aria-label={title}
      onClick={open}
    >
      <i className="fas fa-cubes" aria-hidden="true"></i> {count}
    </a>,
    headerTools,
  )
}
